import {Component} from "@angular/core";
import {EmailSettingSearchModel} from "../email-setting-search.model";
import {EmailSettingEntityModel} from "../email-setting-entity.model";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-email-setting-search-page",
    templateUrl: "./email-setting-search-page.component.html",
    providers: [provideSearchModel(EmailSettingSearchModel), provideEntityModel(EmailSettingEntityModel)]
})
export class EmailSettingSearchPageComponent extends AbstractSearchPage {
    constructor() {
        super();
    }
}
